module.exports = __webpack_public_path__ + "img/bologna.47ed526a.png";